import styled from '@emotion/styled';

import { useRefinedConsoleMenuState } from '../../../../hooks';
import CategorySection from './CategorySection';

const AllServiceContent = () => {
  const { allServices } = useRefinedConsoleMenuState();

  return (
    <AllServiceContainerWrapper>
      <AllServiceContainer>
        {allServices.map(category => {
          return (
            <AllServiceCategoryContainer key={category.name}>
              <CategorySection category={category} type={'all'} />
            </AllServiceCategoryContainer>
          );
        })}
      </AllServiceContainer>
    </AllServiceContainerWrapper>
  );
};

const AllServiceContainerWrapper = styled.div`
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
`;

const AllServiceContainer = styled.ul`
  --column-count: 3;
  --column-gap: 20px;
  width: calc((300px * var(--column-count)) + (var(--column-gap) * (var(--column-count) - 1)));
  column-count: 3;
  column-gap: var(--column-gap);
`;

const AllServiceCategoryContainer = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  break-inside: avoid-column;
`;

export default AllServiceContent;
